import React, { useContext, useEffect } from "react";
import { LinkButtonPrimary, LinkButtonPrimaryBorder } from "@ui/buttons";
import BusyToggleState from "@ui/busy-toggle";
import PageActionContext from "@stores/page-action-context";
import { useNavigate } from "react-router-dom";
import { IconArrowLeft } from "@ui/icons";

const PageActionGroup = (props) => {
    const pageActionCxt = useContext(PageActionContext);
    const navigate = useNavigate();

    const { data } = props;

    useEffect(() => {
        const isNextDisabled = data.nextBtn?.disabled;
        if (isNextDisabled === null || isNextDisabled === undefined) {
            return;
        }
        pageActionCxt.setNextDisabled(isNextDisabled);
    }, []);

    const redirect = (url, external) => {
        if (external) {
            document.location.replace(url);
        } else {
            navigate(url, { replace: true });
        }
    };

    const gaTrackClick = (data) => {
        if (data.isNextGaTracking && app.tracking) {            
            const clickvalue = data.nextBtn?.attributes["data-webm-clickvalue"];
            const section = data.nextBtn?.attributes["data-webm-section"];
            app.tracking.sendGaClick(section, clickvalue, data);
        }        
    }    

    const handleNextClicked = (e) => {
        e.preventDefault();
        gaTrackClick(data);

        if (data.openNextInNewWindow) {
            window.open(data.nextBtn.url);
            return;
        } else if (data.skipNextCustomEvent) {
            redirect(data.nextBtn.url, data.nextBtn.external);
            return;
        }

        if (pageActionCxt.handleNextClick) {
            pageActionCxt.handleNextClick({
                url: data.nextBtn.url,
                isExternal: data.nextBtn.external,
            });
        }
    };

    const handleBackClicked = (e) => {
        e.preventDefault();
        if (data.skipBackCustomEvent) {
            redirect(data.backBtn.url, data.backBtn.external);
            return;
        }
        if (pageActionCxt.handleBackClick) {
            e.preventDefault();
            pageActionCxt.handleBackClick({
                url: data.backBtn.url,
                isExternal: data.backBtn.external,
            });
        }
    };

    useEffect(() => {
        if (data.isNextEnabled !== undefined && data.isNextEnabled !== null) {
            pageActionCxt.setNextDisabled(!data.isNextEnabled);
        }
        if (data.isBackEnabled !== undefined && data.isBackEnabled !== null) {
            pageActionCxt.setPrevDisabled(!data.isBackEnabled);
        }
    }, []);

    if (data.useHorizontalLayout) {
        return (
            <div className="flex items-center justify-between">
                {data.backBtn && (
                    <LinkButtonPrimaryBorder
                        {...data.backBtn}
                        className="inline-block font-normal  border-0 px-0"
                        onClick={handleBackClicked}
                    >
                        <IconArrowLeft /> {data.backBtn.text}
                    </LinkButtonPrimaryBorder>
                )}

                {data.nextBtn && (
                    <LinkButtonPrimary
                        {...data.nextBtn}
                        disabled={pageActionCxt.isNextDisabled}
                        className="inline-block"
                        onClick={handleNextClicked}
                        postImage={data.nextBtnPostImage}
                    >
                        <BusyToggleState
                            isBusy={pageActionCxt.isNextBusy}
                            text="Processing..."
                        >
                            {data.nextBtn.text}
                            {data.nextBtnPostIcon && <img href={data.nextBtnPostIcon}/>}
                        </BusyToggleState>
                    </LinkButtonPrimary>
                )}
            </div>
        );
    }

    return (
        <>
            {data.nextBtn && <LinkButtonPrimary
                {...data.nextBtn}
                disabled={pageActionCxt.isNextDisabled}
                className=""
                onClick={handleNextClicked}
                postImage={data.nextBtnPostImage}
            >
                <BusyToggleState
                    isBusy={pageActionCxt.isNextBusy}
                    text="Processing..."
                >
                    {data?.nextBtn?.text}
                </BusyToggleState>
            </LinkButtonPrimary>}
            {data.backBtn && <LinkButtonPrimaryBorder
                {...data.backBtn}
                className="mt-3"
                onClick={handleBackClicked}
            >
                {data?.backBtn?.text}
            </LinkButtonPrimaryBorder>}
            {props.children}
        </>
    );
};

export default PageActionGroup;
